import {
  Box,
  Button,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconArrowLeft, IconCheck } from "@tabler/icons-react";
import { sky_blue } from "../../../const/variables";
import { modals } from "@mantine/modals";
import { DateTimePicker } from "@mantine/dates";
import { AssignmentWarrantyCompany } from "../../../model/AssignWarrantyCompany";
import { useEffect, useState } from "react";
import { handleKeyDown } from "../../../_base/helper/FunctionHelper";
import { getTblDMBrandSelect } from "../../../service/getSelectApi";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { hasLength, useForm } from "@mantine/form";

const UpdateAssignWarrantyCompany = ({
  id,
  detailId,
  onClose,
  branchIdProp,
}: {
  id: any;
  detailId: any;
  onClose: any;
  branchIdProp: any;
}) => {
  const entity = {
    id: id,
    requestFormId: detailId,
    empCallId: null,
    brandId: null,
    empBrand: null,
    empTracking: null,
    phoneBrand: null,
    addressBrand: null,
    noteBrand: null,
    dateCall: null,
    scheduleTime: null,
    deadline: null,
    status: false,
    po: null,
  };

  const form = useForm<AssignmentWarrantyCompany>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      deadline: (value, values) =>
        !value
          ? "Vui lòng nhập hạn xử lý !"
          : new Date(value) < new Date(values.dateCall ?? "") ||
            new Date(value) < new Date(values.scheduleTime ?? "")
          ? "Hạn xử lý không được trước thời gian liên hệ và ngày hẹn !"
          : null,
      empCallId: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập nhân viên liên hệ !";
        }
      },
      dateCall: (value, values) =>
        !value
          ? "Vui lòng nhập thời gian liên hệ"
          : new Date(value) > new Date(values.deadline ?? "") ||
            new Date(value) > new Date(values.scheduleTime ?? "")
          ? "Thời gian liên hệ không được sau sau ngày hẹn và hạn xử lý !"
          : null,
      scheduleTime: (value, values) =>
        !value
          ? "Vui lòng chọn ngày hẹn gặp !"
          : new Date(value) > new Date(values.deadline ?? "") ||
            new Date(value) < new Date(values.dateCall ?? "")
          ? "Ngày hẹn không được sau hạn xử lý và trước thời gian liên hệ !"
          : null,
      brandId: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập tên hãng !";
        }
      },
      empBrand: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên nhân viên hãng !";
        }
      },
      empTracking: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập tên nhân viên theo dõi !";
        }
      },
      phoneBrand: (value: string | null) => {
        if (value) {
          return hasLength(
            { min: 8, max: 10 },
            "Số điện thoại chưa đúng định dạng !"
          )(value as string);
        }
      },
      addressBrand: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập địa chỉ hãng !";
        }
      },
      noteBrand: (value: string | null) => {
        if (value) {
          return hasLength(
            { max: 250 },
            "Ghi chú không được vượt quá 250 kí tự !"
          )(value as string);
        }
      },
    },
  });

  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataBrandSelect, setDataBrandSelect] = useState<ComboboxItem[]>([]);

  const [visible, { close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);

  const handleUpdateWarrantyBrand = async (
    dataSubmit: AssignmentWarrantyCompany
  ) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<AssignmentWarrantyCompany>
    >(
      "/api/v1/TblWarrantyServiceRequestForm/update-employee-brand",
      dataSubmit
    );
    if (dataApi?.success) {
      modals.closeAll();
      NotificationExtension.Success("Phân công thành công !");
      onClose((prev: any) => !prev);
    }
    close();
  };

  const getUpdateWarrantyBrand = async () => {
    open();
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblWarrantyServiceRequestForm/update-detail?id=${id}`
    );

    if (res) {
      const dataApi = res?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  const getDataEmployeeForDep = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?BranchId=${branchIdProp}&Take=200`
    );

    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          ?.filter(
            (item: any) =>
              item.id != null &&
              item.fullname != null &&
              item.attribute1 === "2"
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: item.fullname,
          }))
      );
    }
  };

  const fetchDataBrand = async () => {
    const get = await getTblDMBrandSelect();
    setDataBrandSelect(
      get
        .filter((item) => item.value != null && item.text != null)
        .map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  useEffect(() => {
    getDataEmployeeForDep();
    fetchDataBrand();
  }, []);

  useEffect(() => {
    if (id) {
      getUpdateWarrantyBrand();
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  useEffect(() => {
    setEnable(form.isDirty());
  }, [form]);

  return (
    <Box
      component="form"
      mx="auto"
      style={{ position: "relative" }}
      maw={750}
      w={"50vw"}
      onSubmit={form.onSubmit((e: AssignmentWarrantyCompany) => {
        handleUpdateWarrantyBrand(e);
      })}
    >
      <Grid mt={10}>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <DateTimePicker
            label="Hạn xử lý"
            placeholder="Chọn hạn xử lý"
            value={
              form.getValues().deadline
                ? new Date(form.getValues().deadline ?? "")
                : undefined
            }
            valueFormat="DD/MM/YYYY HH:mm A"
            locale="vi"
            clearable
            {...form.getInputProps("deadline")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                deadline: e ? new Date(e ?? "").toLocaleString() : null,
              }))
            }
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <TextInput
            label="Số chứng từ"
            placeholder="Nhập số chứng từ"
            variant="filled"
            readOnly
            {...form.getInputProps("po")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <Select
            label="Nhân viên liên hệ"
            placeholder="Nhập tên nhân viên liên hệ"
            data={dataEmployeeSelect}
            comboboxProps={{ width: 200 }}
            searchable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            {...form.getInputProps("empCallId")}
            value={form.getValues().empCallId?.toString() ?? ""}
            onChange={(e) =>
              form.setValues((prev) => ({ ...prev, empCallId: Number(e) }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <Select
            label="Nhân viên theo dõi"
            placeholder="Nhập tên nhân viên theo dõi"
            data={dataEmployeeSelect}
            comboboxProps={{ width: 200 }}
            searchable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...form.getInputProps("empTracking")}
            value={form.getValues().empTracking?.toString() ?? ""}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                empTracking: e ? Number(e) : null,
              }))
            }
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <DateTimePicker
            label="Thời gian liên hệ"
            placeholder="Thời gian liên hệ"
            valueFormat="DD/MM/YYYY HH:mm A"
            value={
              form.getValues().dateCall
                ? new Date(form.getValues().dateCall ?? "")
                : null
            }
            locale="vi"
            clearable
            withAsterisk
            {...form.getInputProps("dateCall")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                dateCall: e ? new Date(e ?? "").toLocaleString() : null,
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <DateTimePicker
            label="Ngày hẹn"
            placeholder="Chọn ngày hẹn"
            valueFormat="DD/MM/YYYY HH:mm A"
            locale="vi"
            minDate={new Date()}
            value={
              form.getValues().scheduleTime
                ? new Date(form.getValues().scheduleTime ?? "")
                : undefined
            }
            clearable
            withAsterisk
            {...form.getInputProps("scheduleTime")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                scheduleTime: e ? new Date(e ?? "").toLocaleString() : null,
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <Select
            label="Hãng"
            placeholder="Nhập tên hãng"
            data={dataBrandSelect}
            value={form.getValues().brandId?.toString() ?? ""}
            searchable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            onChange={(e) =>
              form.setValues((prev) => ({ ...prev, brandId: Number(e) }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <TextInput
            label="Nhân viên hãng nhận"
            placeholder="Nhập tên nhân viên hãng"
            withAsterisk
            {...form.getInputProps("empBrand")}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
          <TextInput
            label="SĐT hãng"
            placeholder="Nhập SĐT hãng"
            onKeyDown={handleKeyDown}
            type="number"
            {...form.getInputProps("phoneBrand")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 9 }}>
          <TextInput
            label="Địa chỉ hãng"
            placeholder="Nhập địa chỉ hãng"
            {...form.getInputProps("addressBrand")}
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            {...form.getInputProps("noteBrand")}
          />
        </Grid.Col>
      </Grid>

      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
          leftSection={!visible ? <IconArrowLeft size={18} /> : undefined}
        >
          Quay lại
        </Button>
        <Button
          type="submit"
          color={sky_blue.base}
          loading={visible}
          leftSection={!visible ? <IconCheck size={18} /> : undefined}
        >
          Lưu
        </Button>
      </Group>
    </Box>
  );
};

export default UpdateAssignWarrantyCompany;
